<template>
  <!-- This component doesn't need hydration, so we don't pass any params -->
  <LazyHydrate>
    <!-- We add this here so ESLint doesn't complain because the template is empty -->
    <noscript v-bind="$attrs" />
  </LazyHydrate>
</template>

<script setup>
import { computed } from 'vue'
import { useHead } from '@unhead/vue'
import { usePageContext } from '../renderer/usePageContext'

const props = defineProps({
  blok: {
    type: Object,
    default: () => {},
  },
  context: {
    type: Object,
    default: () => {},
  },
})

const nonce = usePageContext().nonce
const head = computed(() => ({
  style: [
    {
      nonce,
      innerHTML: props.blok.cssRules.value,
      tagPriority: 'high',
    },
  ],
}))

useHead(head, { mode: import.meta.env.VITE_IS_EDITOR ? 'client' : 'server' })
</script>
